import React from "react";

import { SearchInput } from "@features/search-input";

import { usePageConfiguration } from "./hooks";
import { useActiveTab } from "./hooks/use-active-tab";

export const SearchForm = () => {
  const { searchQuery, setSearchQuery } = usePageConfiguration();
  const { isCampaignTab } = useActiveTab();

  return (
    <SearchInput
      target="sales-page"
      searchQuery={searchQuery}
      showCampaignLabel={isCampaignTab}
      onChange={setSearchQuery}
    />
  );
};
